module.exports = __webpack_public_path__ + "static/img/upload.4e978e98.png";